import Api from "./api";

class CatalogService {

    api = new Api();

    getSuperGroups() {
        return this.api.get('/admin/catalog/get-super-groups');
    }

    addSuperGroup(name, choose) {
        return this.api.post('/admin/catalog/add-super-group', {
            name: name,
            status: choose,
        });
    }

    getGroups(superGroupId) {
        return this.api.get('/admin/catalog/get-groups', {
            superGroupId: superGroupId
        })
    }

    addGroup(parentId, name, choose) {
        return this.api.post('/admin/catalog/add-group', {
            parentId: parentId,
            name: name,
            status: choose
        })
    }

    updateGroup(groupId, name, choose) {
        return this.api.post('/admin/catalog/update-group', {
            groupId: groupId,
            name: name,
            status: choose
        })
    }

    removeGroup(groupId) {
        return this.api.post('/admin/catalog/remove-group', {
            groupId: groupId
        });
    }

    addSubGroup(groupId, name, choose) {
        return this.api.post('/admin/catalog/add-sub-group', {
            groupId: groupId,
            name: name,
            status: choose
        })
    }

    updateSubGroup(groupId, name, choose) {
        return this.api.post('/admin/catalog/update-sub-group', {
            groupId: groupId,
            name: name,
            status: choose
        })
    }

    getSubGroups(groupId) {
        return this.api.get('/admin/catalog/get-sub-groups', {
            groupId: groupId
        })
    }

    removeSubGroup(subGroupId) {
        return this.api.post('/admin/catalog/remove-sub-group', {
            subGroupId: subGroupId
        })
    }

    getAttributes(subGroupId) {
        return this.api.post('/admin/catalog/get-attributes', {
            subGroupId: subGroupId
        })
    }

    getPossibleValues(attributeId, categoryId) {
        return this.api.get('/admin/catalog/get-possible-values', {
            attributeId: attributeId,
            categoryId: categoryId
        })
    }

    saveAttributeProperties(categoryId, attributeId, name, possibleValues, isMain) {
        return this.api.post('/admin/catalog/update-attribute-properties', {
            categoryId: categoryId,
            attributeId: attributeId,
            name: name,
            possibleValues: possibleValues,
            isMain: isMain
        })
    }

    removeAttribute(attributeId, categoryId) {
        return this.api.post('/admin/catalog/remove-attribute', {
            categoryId: categoryId,
            attributeId: attributeId
        });
    }
}

export default new CatalogService();